import styled, { css } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledTitleTagWrapper = styled.div(({ theme }) => {
  return css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    padding-top: ${utils.rem(theme.Spacing.Size.XSmall)};
  `;
});
